// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Box_wrapper__QJFOq","view-relative":"Box_view-relative__gfh9_","view-largePadding":"Box_view-largePadding__viwDh"};